import React, {Component} from "react";
import {getTableConfig} from "../configs/config";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import StockOpnameFooter from "./stockOpnameFooter";

class StockOpnameDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumn: [],
            dataTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount() {
        this.setState({
            tableColumn: getTableConfig(
                this.props.tab,
                this.props.controls.stockOpnameType?.value?.value || null,
                this.props.onDataTableChange,
                this.props.onDeleteRow
            )
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.controls.stockOpnameType !== this.props.controls.stockOpnameType) {
            this.setState({
                tableColumn: getTableConfig(
                    this.props.tab,
                    this.props.controls.stockOpnameType?.value?.value || null,
                    this.props.onDataTableChange,
                    this.props.onDeleteRow
                )
            });
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleDataTable
                    key={`${this.props.dataTable?.length}-${this.state.pagination.page}`}
                    data={this.props.dataTable}
                    columns={this.state.tableColumn}
                    toCount={this.props.dataTable?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
                <StockOpnameFooter tab={this.props.tab} totalProcess={this.props.totalProcess}/>
            </>
        )
    }
}

export default StockOpnameDetail;